import * as React from "react";

const IconH2Flair: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="currentColor"><polygon fill="#003594" fillRule="evenodd" points="25 29 25 3 0 3" transform="translate(0 -3)"/></svg>;
};

export default React.memo(IconH2Flair);
